import React from 'react';

import { CollectionProvider } from './CollectionProvider';
import { SheetsCommonProvider } from './CommonProvider';
import { SearchPanelProvider } from './SearchPanelProvider';
import { SheetFilterProvider } from './SheetFilterProvider';

const SheetsProvider = ({ children, sheetContainerType, sheetParser }) => {
  return (
    <SheetsCommonProvider
      sheetContainerType={sheetContainerType}
      sheetParser={sheetParser}
    >
      <CollectionProvider>
        <SheetFilterProvider>
          <SearchPanelProvider>{children}</SearchPanelProvider>
        </SheetFilterProvider>
      </CollectionProvider>
    </SheetsCommonProvider>
  );
};

SheetsProvider.displayName = 'SheetsProvider';

export default SheetsProvider;
